/* eslint-disable react/prop-types */
import React, { useCallback, useContext } from "react";

// components
import BuyOperation from "../../../components/contractListItem/buy";
import SellOperation from "../../../components/contractListItem/sell";
import Broker from "../../../components/contractListItem/broker";

// types
import { USER_ROLE } from "../../../enums";

// types
import {
  EContractType,
  ESenderRole,
} from "../../../setup/api/services/contract/models";

// context providers
import { AuthConfig } from "../../../setup/context/config/authConfig";
import { ContractContext } from "../../../providers/contract";

const ContractType = () => {
  const { contract } = useContext(ContractContext);
  const userId = AuthConfig.getUserInfo()?.id;
  // eslint-disable-next-line react/prop-types

  const renderContractType = useCallback(
    ({ userRole, text }: { userRole: USER_ROLE; text?: string }) => {
      switch (userRole) {
        case USER_ROLE.BROKER:
          return <Broker text={text} />;
        case USER_ROLE.BUYER:
          return <BuyOperation text={text} />;
        case USER_ROLE.SELLER:
          return <SellOperation text={text} />;
        default:
          return <Broker text={text} />;
      }
    },
    []
  );

  const getContractType = useCallback(() => {
    if (!contract) return { userRole: USER_ROLE.BUYER };
    if (contract?.type === EContractType.BROKERAGE_CONTRACT)
      return { userRole: USER_ROLE.BROKER };
    if (contract.senderRole === ESenderRole.CUSTOMER) {
      return { userRole: USER_ROLE.BUYER };
    }
    if (
      (contract.senderId == userId &&
        contract.senderRole === ESenderRole.PROVIDER) ||
      contract?.receiverId != userId
    ) {
      return { userRole: USER_ROLE.SELLER };
    } else {
      return { userRole: USER_ROLE.BUYER };
    }
  }, [contract, userId]);

  if (!contract) return null;

  return <>{renderContractType(getContractType())}</>;
};

export default ContractType;
